import { FC } from 'react'

interface IProps {}

const Error: FC<IProps> = ({}) => {
  return <div>Not found</div>
}

export default Error
